export const APP_NAME = 'VoiceKit';
export const APP_VERSION = '0.0.0';
